export enum SchemaEditorVariant {
  FUNCTIONS = 'functions',
  EVALUATOR = 'evaluator',
  SCHEMA = 'schema',
  NESTED = 'nested',
}

export const VARIANT_PROPERTY_LABEL_MAP = {
  [SchemaEditorVariant.FUNCTIONS]: 'argument',
  [SchemaEditorVariant.EVALUATOR]: 'criteria',
  [SchemaEditorVariant.SCHEMA]: 'property',
  [SchemaEditorVariant.NESTED]: 'property',
};

export const VARIANT_LABEL_MAP = {
  [SchemaEditorVariant.FUNCTIONS]: 'Tool',
  [SchemaEditorVariant.EVALUATOR]: 'Evaluator',
  [SchemaEditorVariant.SCHEMA]: 'Schema',
  [SchemaEditorVariant.NESTED]: 'Schema',
};
